// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/**\n*  Start Bootstrap overrides\n*/", "",{"version":3,"sources":["webpack://./src/styles/_variables.scss"],"names":[],"mappings":"AAmEA;;CAAA","sourcesContent":["// Colors\n$color-primary-blue: #0d61a7;\n$color-secondary-blue: #003c6c;\n$color-tertiary-blue: #a8cae7;\n$color-light-blue: #e9eff3;\n$color-lighter-blue: #1076c8;\n$color-button-blue: #005598;\n$color-blueridge-blue: #174973;\n$color-blueridge-dark-blue: #003d6b;\n$color-blueridge-ultra-light-blue: #b6cfe3;\n$color-button-border: #01467d;\n$color-lightest-gray: #f8f8f8;\n$color-lighter-gray: #f7f7f7;\n$color-light-gray: #cdcdcd;\n$color-gray: #a3a3a3;\n$color-medium-gray: #dee2e6;\n$color-medium-gray2: #a3a3a3;\n$color-darker-gray: #9a9a9a;\n$color-darkest-gray: #666;\n$color-blueridge-gray: #999999;\n$color-green: #00a651;\n$color-dark-green: #2ba651;\n$color-light-green: #90d478;\n$color-light-green2: #dff0d8;\n$color-light-green3: #90d478af;\n$color-bright-green: #17ad15;\n$color-red: #ff0000;\n$color-dark-red: #d31200;\n$color-pink: #fee7ef;\n$color-blueridge-gold: #f5b700;\n$color-orange: #f8a22c;\n$color-orange-red: #ce6601;\n$color-dark-orange: #ec7300;\n$color-light-orange: #fda06d;\n$color-light-orange2: #fee3d1;\n$color-light-black: #22272b;\n$color-almost-black: #333;\n$color-black: #343a40;\n$color-white: #fff;\n$color-off-white: #f8f8f8;\n$color-canary-yellow: rgb(255, 255, 204);\n\n// PNet Colors\n$color-pnet-green: #beeed1;\n$color-pnet-orange: #fbb648;\n$color-pnet-gray: #555;\n$color-pnet-blue: #337ab7;\n\n// Gradients\n$gradient-orange: linear-gradient(to bottom, #fb9001 0%, #ee7600 100%);\n$gradient-blue: linear-gradient(to bottom, #0064b4 0%, #004b86 100%);\n$gradient-dark-blue: linear-gradient(to bottom, #004b86 0%, #003c6c 100%);\n$gradient-dark-blue-invert: linear-gradient(\n\tto bottom,\n\t#003c6c 0%,\n\t#004b86 100%\n);\n\n// Fonts\n$font-open-sans: 'Open Sans', sans-serif;\n$font-size-primary: 1rem;\n\n$font-pixels: 16;\n\n// Z-indices\n$header-z-index: 1070;\n\n/**\n*  Start Bootstrap overrides\n*/\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n$grid-breakpoints: (\n\txs: 0,\n\tsm: 576px,\n\tmd: 768px,\n\tlg: 992px,\n\txl: 1200px\n) !default;\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n$container-max-widths: (\n\tsm: 540px,\n\tmd: 720px,\n\tlg: 960px,\n\txl: 1190px\n) !default;\n\n$input-border-color: $color-light-gray;\n$input-border-radius: 1px;\n$grid-gutter-width: 20px;\n$popover-font-size: 0.8125rem;\n$custom-select-border-radius: 0;\n\n$shadow-bottom: 0 0 8px rgba(0, 0, 0, 0.12), 0 0 5px rgba(0, 0, 0, 0.24);\n// <================ NEW STYLE GUIDE ===============>\n$color-alpine-blue-sky: #a7d8ff;\n$color-alpine-blue-light: #0082e9;\n$color-alpine-blue: #0061ae;\n$color-alpine-blue-dark: #003c6c;\n\n$color-alpine-orange-light: #ffae00;\n$color-alpine-orange: #ff8700;\n$color-alpine-orange-dark: #ce6601;\n\n$color-alpine-gray-light: #f8f8f8;\n$color-alpine-gray: #cdcdcd;\n$color-alpine-gray-medium: #a3a3a3;\n$color-alpine-gray-dark: #666;\n$color-alpine-black: #333;\n\n$color-alpine-green-light: #89d373;\n$color-alpine-green: #00a651;\n$color-alpine-green-dark: #068300;\n\n$color-alpine-peach: #fda06d;\n\n$color-alpine-red: #ff0000;\n$color-alpine-dark-red: #d31200;\n$color-alpine-light-red: #ffe2e2;\n\n$font-normal: 400;\n$font-semibold: 600;\n$font-bold: 700;\n\n$font-size-large: 1.375rem;\n$font-size-normal: 0.9375rem;\n$font-size-small: 0.8125rem;\n$font-size-extra-small: 0.6875rem;\n\n$heading-size-1: 1.625rem;\n$heading-size-2: 1.5rem;\n$heading-size-3: 1.375rem;\n$heading-size-4: 1.25rem;\n$heading-size-5: 1.125rem;\n$heading-size-6: 1rem;\n\n$border-radius-small: 0.1875rem;\n$border-radius-large: 0.56rem;\n$border-radius-circle: 100%;\n\n$shadow-bottom: 0 0 8px rgba(0, 0, 0, 0.12), 0 0 5px rgba(0, 0, 0, 0.24);\n// <================ NEW STYLE GUIDE ===============>\n\n// new colors added from \"match the live site\" tickets, they should be refactored to re-use colors in the NEW STYLE GUIDE at some point\n$color-live-blue: #0060ad;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colorAlpineBlue": "#0061ae",
	"colorAlpineBlueDark": "#003c6c",
	"colorAlpineBlueLight": "#0082e9",
	"colorAlpineBlueSky": "#a7d8ff",
	"colorAlpineGreen": "#00a651",
	"colorAlpineGreenDark": "#068300",
	"colorAlpineGreenLight": "#89d373",
	"colorAlpineOrange": "#ff8700",
	"colorAlpineOrangeDark": "#ce6601",
	"colorAlpineOrangeLight": "#ffae00",
	"colorAlpineGray": "#cdcdcd",
	"colorAlpineGrayLight": "#f8f8f8",
	"colorAlpineGrayMedium": "#a3a3a3",
	"colorAlpineGrayDark": "#666",
	"colorAlpineBlack": "#333",
	"colorAlpinePeach": "#fda06d",
	"colorAlpineRed": "#ff0000",
	"colorAlpineDarkRed": "#d31200",
	"colorAlpineLightRed": "#ffe2e2",
	"colorLiveBlue": "#0060ad",
	"colorPrimaryBlue": "#0d61a7",
	"colorSecondaryBlue": "#003c6c",
	"colorTertiaryBlue": "#a8cae7",
	"colorLightBlue": "#e9eff3",
	"colorLighterBlue": "#1076c8",
	"colorButtonBlue": "#005598",
	"colorBlueridgeBlue": "#174973",
	"colorBlueridgeUltraLightBlue": "#b6cfe3",
	"colorBlueridgeDarkBlue": "#003d6b",
	"colorButtonBorder": "#01467d",
	"colorLightGray": "#cdcdcd",
	"colorLighterGray": "#f7f7f7",
	"colorLightestGray": "#f8f8f8",
	"colorGray": "#a3a3a3",
	"colorMediumGray": "#dee2e6",
	"colorMediumGray2": "#a3a3a3",
	"colorDarkerGray": "#9a9a9a",
	"colorDarkestGray": "#666",
	"colorBlueridgeGray": "#999999",
	"colorGreen": "#00a651",
	"colorDarkGreen": "#2ba651",
	"colorLightGreen": "#90d478",
	"colorLightGreen2": "#dff0d8",
	"colorLightGreen3": "rgba(144, 212, 120, 0.6862745098)",
	"colorBrightGreen": "#17ad15",
	"colorBlueridgeGold": "#f5b700",
	"colorOrange": "#f8a22c",
	"colorDarkOrange": "#ec7300",
	"colorLightOrange": "#fda06d",
	"colorLightOrange2": "#fee3d1",
	"colorOrangeRed": "#ce6601",
	"colorRed": "#ff0000",
	"colorDarkRed": "#d31200",
	"colorPink": "#fee7ef",
	"colorBlack": "#343a40",
	"colorWhite": "#fff",
	"colorOffWhite": "#f8f8f8",
	"colorAlmostBlack": "#333",
	"colorLightBlack": "#22272b",
	"colorCanaryYellow": "rgb(255, 255, 204)",
	"colorPnetGreen": "#beeed1",
	"colorPnetOrange": "#fbb648",
	"colorPnetGray": "#555",
	"colorPnetBlue": "#337ab7",
	"gradientOrange": "linear-gradient(to bottom, #fb9001 0%, #ee7600 100%)",
	"gradientBlue": "linear-gradient(to bottom, #0064b4 0%, #004b86 100%)",
	"gradientDarkBlue": "linear-gradient(to bottom, #004b86 0%, #003c6c 100%)",
	"gradientDarkBlueInvert": "linear-gradient(to bottom, #003c6c 0%, #004b86 100%)",
	"fontOpenSans": "\"Open Sans\", sans-serif",
	"fontSizePrimary": "1rem",
	"fontBold": "700",
	"fontSemibold": "600",
	"fontNormal": "400",
	"fontSizeLarge": "1.375rem",
	"fontSizeNormal": "0.9375rem",
	"fontSizeSmall": "0.8125rem",
	"fontSizeExtraSmall": "0.6875rem",
	"headingSize1": "1.625rem",
	"headingSize2": "1.5rem",
	"headingSize3": "1.375rem",
	"headingSize4": "1.25rem",
	"headingSize5": "1.125rem",
	"headingSize6": "1rem",
	"borderRadiusSmall": "0.1875rem",
	"borderRadiusLarge": "0.56rem",
	"borderRadiusCircle": "100%",
	"shadowBottom": "0 0 8px rgba(0, 0, 0, 0.12), 0 0 5px rgba(0, 0, 0, 0.24)",
	"headerZIndex": "1070",
	"containerMedium": "720px",
	"containerLarge": "960px",
	"breakpointExtraSmall": "0",
	"breakpointSmall": "576px",
	"breakpointMedium": "768px",
	"breakpointMediumLarge": "1200px",
	"breakpointLarge": "992px",
	"breakpointExtraLarge": "1200px"
};
export default ___CSS_LOADER_EXPORT___;
